import { render, staticRenderFns } from "./teamChoseMembers.vue?vue&type=template&id=d01b2800"
import script from "./teamChoseMembers.vue?vue&type=script&lang=js"
export * from "./teamChoseMembers.vue?vue&type=script&lang=js"
import style0 from "./teamChoseMembers.vue?vue&type=style&index=0&id=d01b2800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports